// src/services/regionConfig.ts

export interface RegionEntry {
  key: string
  url: string
}

export type RegionMap = Record<string, string>

export function parseRegions(raw: string | undefined): RegionMap {
  if (!raw) return {}
  const map: RegionMap = {}
  for (const pair of raw.split(',')) {
    const [key, ...urlParts] = pair.split(':')
    const trimmedKey = key?.trim()
    const url = urlParts.join(':').trim() // rejoin in case URL has colons
    if (trimmedKey && url) {
      map[trimmedKey] = url
    }
  }
  return map
}

export function getRegionOrder(regions: RegionMap, defaultRegion: string): RegionEntry[] {
  const keys = Object.keys(regions)
  if (!keys.includes(defaultRegion)) {
    defaultRegion = keys.includes('eu') ? 'eu' : keys[0]
  }
  const sorted = [defaultRegion, ...keys.filter(k => k !== defaultRegion)]
  return sorted.map(key => ({ key, url: regions[key] }))
}

// Singleton config parsed from env vars
const REGIONS = parseRegions(import.meta.env.VITE_REGIONS)
const DEFAULT_REGION = import.meta.env.VITE_DEFAULT_REGION || 'eu'

export const regionConfig = {
  regions: REGIONS,
  defaultRegion: DEFAULT_REGION,
  isMultiRegion: Object.keys(REGIONS).length > 1,
  getOrder: () => getRegionOrder(REGIONS, DEFAULT_REGION),
}
